<template>
  <ConfirmDialog group="dialog" :draggable="false" />
  <ConfirmDialog :draggable="false" />
  <DynamicDialog />
  <AppPreviewInfo />
  <LazyAppLayoutsAppComponents v-if="$sharedComponentsOptions.plugins?.layouts" />
  <LazyIdleAppToast hydrate-on-idle />
  <LazyAppScannerDialog v-if="$sharedComponentsPlugins.scanner" />
</template>
<script setup lang="ts">
const { $sharedComponentsOptions, $sharedComponentsPlugins, $auth } = useNuxtApp()

if ($sharedComponentsOptions.plugins?.versioning) {
  const { isNewVersionAvailable, onCheck } = useVersion()
  if ($sharedComponentsOptions.plugins?.primevue) {
    const { addInfoMessage } = useToastService()
    const { t } = useI18n()
    watch(isNewVersionAvailable, (value) => {
      if (value) {
        addInfoMessage(t('Je k dispozici nová verze aplikace'), null, 60000, undefined, {
          label: t('Obnovit'),
          click: () => reloadNuxtApp(),
        })
      }
    })
  }
  if ($sharedComponentsOptions.plugins?.auth) {
    const { checkSession } = $auth
    onCheck(() => {
      if ($auth.auth.value.user) {
        checkSession()
      }
    })
  }
}
</script>
